module.exports = __webpack_public_path__ + "assets/ic_tree01.627cc46f.svg";